import { Routes } from '@angular/router';
import { RegisterComponent } from './pages/public/register/register.component';
import { VerifyOtpComponent } from './pages/public/verify-otp/verify-otp.component';
import { LayoutComponent } from './shared/layout/layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { GuestGuard } from './core/guards/guest.guard';

import { ParkingCenterComponent } from './pages/private/out-category/parking-map/parking-center/parking-center.component';
import { CheckintOptionComponent } from './pages/private/out-category/unknow/checkin-option/checkin-option.component';
import { MemberSuccessfulComponent } from './pages/private/member-information-category/member-card/member-successful/member-successful.component';
import { LiffLoaderComponent } from './pages/public/liff-loader/liff-loader.component';
import { ReceiptPageComponent } from './pages/private/history-category/payment-history/receipt-page/receipt-page.component';
import { DiscountRequestComponent } from './pages/private/services-catagory/discount/discount-request/discount-request.component';
import { ProfileComponent } from './pages/private/out-category/profile/profile/profile.component';
import { AddressComponent } from './pages/private/out-category/profile/address/address.component';
import { SettingComponent } from './pages/private/support-category/setting/setting/setting.component';
import { ReportMainComponent } from './pages/private/support-category/report/report-main/report-main.component';
import { ReportOtherComponent } from './pages/private/support-category/report/report-other/report-other.component';
import { EvChargerComponent } from './pages/private/services-catagory/ev-charger/ev-charger/ev-charger.component';
import { Home2Component } from './pages/private/home/home-2/home-2.component';
import { TopUpComponent } from './pages/private/out-category/top-up/top-up/top-up.component';
import { VehiclesOption2Component } from './pages/private/member-information-category/vehicle/vehicles-option-2/vehicles-option-2.component';
import { VehiclesSetting2Component } from './pages/private/member-information-category/vehicle/vehicles-setting-2/vehicles-setting-2.component';
import { MyMemberCard2Component } from './pages/private/services-catagory/my-member-card-2/my-member-card-2.component';
import { ServiceProviders2Component } from './pages/private/services-catagory/provider/service-providers-2/service-providers-2.component';
import { Invite2Component } from './pages/private/services-catagory/invite/invite-2/invite-2.component';
import { ParkingHistory2Component } from './pages/private/history-category/parking-history/parking-history-2/parking-history-2.component';
import { CheckAmountParkingComponent } from './pages/private/services-catagory/parking/check-amount-parking/check-amount-parking.component';
import { TopupHistoryComponent } from './pages/private/out-category/top-up/topup-history/topup-history.component';
import { PaymentHistory2Component } from './pages/private/history-category/payment-history/payment-history-2/payment-history-2.component';
import { RequestMenu2Component } from './pages/private/support-category/request/request-menu-2/request-menu-2.component';
import { MemberVehicleForm2Component } from './pages/private/member-information-category/member-card/member-vehicle-form-2/member-vehicle-form-2.component';
import { EvChargerDetail2Component } from './pages/private/services-catagory/ev-charger/ev-charger-detail-2/ev-charger-detail-2.component';
import { EvChargerHistoryComponent } from './pages/private/services-catagory/ev-charger/ev-charger-history/ev-charger-history.component';
import { ActivateMemberCardComponent } from './pages/private/services-catagory/activate/activate-member-card/activate-member-card.component';
import { ActivateMemberCardFormComponent } from './pages/private/services-catagory/activate/activate-member-card-form/activate-member-card-form.component';
import { EvChargerInvoiceComponent } from './pages/private/services-catagory/ev-charger/ev-charger-invoice/ev-charger-invoice.component';
import { PaymentServicesComponent } from './pages/private/services-catagory/payment/payment-services/payment-services.component';
import { VehicleShareComponent } from './pages/private/member-information-category/vehicle/vehicle-share/vehicle-share.component';
import { VehicleShareFormComponent } from './pages/private/member-information-category/vehicle/vehicle-share-form/vehicle-share-form.component';
import { OptionRegisterRenewComponent } from './pages/private/services-catagory/option-register-renew/option-register-renew.component';
import { ProfileEditComponent } from './pages/private/out-category/profile/profile-edit/profile-edit.component';
import { VehicleShareInboxComponent } from './pages/private/member-information-category/vehicle/vehicle-share-inbox/vehicle-share-inbox.component';
import { PomotionnInfoComponent } from './pages/private/out-category/pomotionn-info/pomotionn-info.component';
import { RegisterMemberComponent } from './pages/private/services-catagory/register-member/register-member/register-member.component';
import { TopUpEvChargerComponent } from './pages/private/out-category/top-up/top-up-ev-charger/top-up-ev-charger.component';
import { TopupHistoryEvChargerComponent } from './pages/private/out-category/top-up/topup-history-ev-charger/topup-history-ev-charger.component';
import { CustomerServiceCaseComponent } from './pages/private/support-category/request/customer-service-case/customer-service-case.component';
import { NewsListComponent } from './pages/private/out-category/news/news-list/news-list.component';
import { NewsDetailComponent } from './pages/private/out-category/news/news-detail/news-detail.component';
import { ParkingSiteDetailComponent } from './pages/private/out-category/parking-site/parking-site-detail/parking-site-detail.component';
import { ManualLayoutComponent } from './pages/manual/manual-layout/manual-layout.component';
import { ManualHomeComponent } from './pages/manual/manual-home/manual-home.component';
import { ManualMemberQrComponent } from './pages/manual/manual-member-qr/manual-member-qr.component';
import { ManualGuidesComponent } from './pages/manual/manual-guides/manual-guides.component';
import { ManualGuideDetailComponent } from './pages/manual/manual-guide-detail/manual-guide-detail.component';
import { ManualReportComponent } from './pages/manual/manual-report/manual-report.component';

export const appRoutes: Routes = [
  // หน้าสาธารณะ
  { path: 'register', component: LiffLoaderComponent }, // ✅ หน้า loader ตรวจ liff login
  {
    path: 'register-form',
    component: RegisterComponent,
    canActivate: [GuestGuard],
  },
  {
    path: 'verify-otp',
    component: VerifyOtpComponent,
    canActivate: [GuestGuard],
  },

  // Manual — ไม่ผ่าน LIFF / AuthGuard (เปิดเบราว์เซอร์ตรงได้)
  {
    path: 'manual',
    component: ManualLayoutComponent,
    children: [
      { path: '', component: ManualHomeComponent },
      { path: 'member-qr', component: ManualMemberQrComponent },
      { path: 'report', component: ManualReportComponent },
      { path: 'guides/:kind', component: ManualGuidesComponent },
      { path: 'guides/:kind/:slug', component: ManualGuideDetailComponent },
    ],
  },

  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      //{ path: 'home', component: HomeComponent },
      { path: 'home', component: Home2Component },
      { path: 'vehicle-setting', component: VehiclesSetting2Component },
      { path: 'vehicle-setting/:id', component: VehiclesSetting2Component },
      { path: 'check-amount-parking', component: CheckAmountParkingComponent },
      { path: 'parking-center', component: ParkingCenterComponent },
      { path: 'checkin-option', component: CheckintOptionComponent },
      { path: 'service-providers', component: ServiceProviders2Component },
      { path: 'register-member-vehicle', component: RegisterMemberComponent },
      { path: 'member-successful', component: MemberSuccessfulComponent },
      { path: 'vehicles-option', component: VehiclesOption2Component },
      { path: 'my-member-card', component: MyMemberCard2Component },
      { path: 'payment-history', component: PaymentHistory2Component },
      { path: 'receipt-page', component: ReceiptPageComponent },
      { path: 'parking-history', component: ParkingHistory2Component },
      { path: 'discount-request', component: DiscountRequestComponent },
      { path: 'member-vehicle-form', component: MemberVehicleForm2Component },
      { path: 'request-menu', component: RequestMenu2Component },
      { path: 'profile', component: ProfileComponent },
      { path: 'profile-edit', component: ProfileEditComponent },
      { path: 'address', component: AddressComponent },
      { path: 'pomotion-info', component: PomotionnInfoComponent },
      { path: 'news', component: NewsListComponent },
      { path: 'news-detail/:id', component: NewsDetailComponent },
      { path: 'lot/:ref', component: ParkingSiteDetailComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'invite', component: Invite2Component },
      { path: 'report-main', component: ReportMainComponent },
      { path: 'report-other', component: ReportOtherComponent },
      { path: 'customer-service-case', component: CustomerServiceCaseComponent },
      { path: 'ev-charger', component: EvChargerComponent },
      { path: 'ev-charger-detail/:id', component: EvChargerDetail2Component },
      { path: 'ev-charger-history', component: EvChargerHistoryComponent },
      { path: 'ev-charger-invoice', component: EvChargerInvoiceComponent },
      { path: 'top-up', component: TopUpComponent },
      { path: 'top-up-ev-charger', component: TopUpEvChargerComponent },
      { path: 'top-up-history', component: TopupHistoryComponent },
      { path: 'top-up-history-ev-charger', component: TopupHistoryEvChargerComponent },
      { path: 'activate-member-card', component: ActivateMemberCardComponent },
      { path: 'activate-member-card-form', component: ActivateMemberCardFormComponent },
      { path: 'payment-services', component: PaymentServicesComponent },
      { path: 'vehicle-share', component: VehicleShareComponent },
      { path: 'vehicle-share-inbox', component: VehicleShareInboxComponent },
      { path: 'vehicle-share-form', component: VehicleShareFormComponent },
      { path: 'option-register-renew', component: OptionRegisterRenewComponent },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
  // fallback — ไม่มี session ต้องเข้าทาง /register (LIFF) ก่อน
  { path: '**', redirectTo: 'register' },
];
